var klaviyo = klaviyo || [];
klaviyo.init({
    account: "WxdpXL",
    platform: "shopify"
});
klaviyo.enable("backinstock",{
    trigger: {
        product_page_text: window.klaviyoStrings.pageTitle,
        product_page_class: "button",
        product_page_text_align: "center",
        product_page_margin: "0px",
        replace_anchor: false
    },
    modal: {
        headline: "{product_name}",
        body_content: window.klaviyoStrings.bodyContent,
        email_field_label: window.klaviyoStrings.emailLabel,
        button_label: window.klaviyoStrings.pageTitle,
        subscription_success_label: "",
        footer_content: '',
        additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
        drop_background_color: "#000",
        background_color: "#fff",
        text_color: "#1B1B1B",
        button_text_color: "#1B1B1B",
        button_background_color: "#D16F3A",
        close_button_color: "#ccc",
        error_background_color: "#fcd6d7",
        error_text_color: "#C72E2F",
        success_background_color: "#d3efcd",
        success_text_color: "#1B9500"
    }
});